(() => {
  const records = {
    inspection: { index: '01', label: 'Inspection', title: 'The inspection record' },
    condition: { index: '02', label: 'Condition', title: 'The condition evidence' },
    status: { index: '03', label: 'Status', title: 'The status record' },
    warranty: { index: '04', label: 'Warranty', title: 'The written warranty' },
  };

  function initialize() {
    const section = document.querySelector('#rh-fusion-evidence');
    const workspace = section?.querySelector('.evidence-workspace');
    const assetData = document.querySelector('#rh-air3-evidence-assets');
    if (!section || !workspace || !assetData || workspace.querySelector('.evidence-mobile-dock')) return;

    const assets = JSON.parse(assetData.textContent);
    const dockLabel = document.createElement('p');
    dockLabel.className = 'evidence-mobile-dock-label';
    dockLabel.textContent = 'EXAMPLE INSPECTION REPORTS';
    const dock = document.createElement('div');
    dock.className = 'evidence-mobile-dock';
    dock.setAttribute('aria-label', 'Choose an evidence report');

    const select = (key, scroll) => {
      const record = records[key];
      const src = assets[key];
      if (!record || !src) return;

      section.querySelectorAll('[data-record]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.record === key));
      });
      dock.querySelectorAll('[data-mobile-record]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.mobileRecord === key));
      });

      const image = section.querySelector('#evidence-image');
      const preview = section.querySelector('#evidence-preview');
      const caption = section.querySelector('.paper-caption');
      const count = section.querySelector('#evidence-count');
      image.src = src;
      image.alt = record.title;
      preview.dataset.evidence = src;
      preview.dataset.title = record.title;
      caption.firstChild.textContent = record.title;
      count.textContent = `${record.index} / 04`;

      if (scroll) workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    Object.entries(records).forEach(([key, record]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'evidence-mobile-tab';
      button.dataset.mobileRecord = key;
      button.setAttribute('aria-label', `Show ${record.title}`);
      button.setAttribute('aria-controls', 'evidence-preview');
      button.setAttribute('aria-pressed', String(key === 'inspection'));
      button.textContent = record.label;
      button.addEventListener('click', () => select(key, true));
      dock.append(button);
    });

    section.querySelectorAll('.evidence-copy [data-record]').forEach((button) => {
      button.addEventListener('click', () => select(button.dataset.record, false));
    });

    workspace.prepend(dockLabel, dock);
    workspace.setAttribute('aria-live', 'polite');
    select('inspection', false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
